import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

const fragments = {
	BTN_REMOVE: '[data-fragment="MailAttachment.remove"]',
};

class MailAttachment extends WebComponent {
	constructor(props) {
		super(props);
	}

	didMount() {
		this.elementBtnRemove = this.element.querySelector(fragments.BTN_REMOVE);
		this.on('click', fragments.BTN_REMOVE, this.handleClickOnBtnRemove.bind(this));
	}

	handleClickOnBtnRemove = (e) => {
		e.preventDefault();
		const attachmentIdInput = document.querySelector('input[name="frm.attachmentId"]');
		attachmentIdInput.value = this.elementBtnRemove.dataset.attachmentId;
		const deleteAttachment = document.querySelector("#deleteAttachment");
		deleteAttachment.click();
	}

}


export default MailAttachment;




// WEBPACK FOOTER //
// ./config/module-publish/resources/js/components/Mailing/MailAttachment.js